import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useAuthStore from "../../store/useAuthStore";

const CTA = () => {
  // Get authentication state
  const { isAuthenticated, checkAuth } = useAuthStore();

  // Check authentication state on component mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <section className="py-10 bg-[#FDD00F] relative overflow-hidden">
      <div className="relative max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl !font-bold text-[#283794] mb-4 leading-tight">
        Ready to Begin Your Trading Journey?
        </h2>
        <p className="text-base md:text-lg text-black font-medium mb-6 leading-relaxed max-w-5xl ">
          Join thousands of traders worldwide who trust P2P1 for their
          cryptocurrency trading needs.
        </p>
        <div
          className="flex flex-col sm:flex-row justify-center gap-3"
        >
          {/* Hide the "Create Free Account" button if the user is logged in */}
          {!isAuthenticated && (
            <Link
              to="/register"
              className="group  bg-[#283794] text-white px-6 py-3 rounded-full font-bold text-sm hover:bg-white hover:!text-black transition-all duration-500 transform hover:scale-105 hover:-translate-y-1 relative overflow-hidden"
            >
              <span className="relative z-10">Create Free Account</span>
              <div className="absolute inset-0 !bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </Link>
          )}
          <Link
            to="/swap"
            className="group border-2 !border-black !text-black px-6 py-3 rounded-full font-bold text-sm hover:bg-white hover:text-blue-600 transition-all duration-500 transform hover:scale-105 hover:-translate-y-1 relative overflow-hidden"
          >
            <span className="relative z-10">Start Trading</span>
            <div className="absolute inset-0 !bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </Link>
        </div>

        {/* Additional decorative elements */}
        <div className="mt-6 flex justify-center space-x-2 opacity-60">
          <div className="w-1 h-1 bg-white rounded-full animate-bounce"></div>
          <div
            className="w-1 h-1 bg-white rounded-full animate-bounce"
            style={{ animationDelay: "0.1s" }}
          ></div>
          <div
            className="w-1 h-1 bg-white rounded-full animate-bounce"
            style={{ animationDelay: "0.2s" }}
          ></div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide {
          0% {
            transform: translateX(0) translateY(0);
          }
          100% {
            transform: translateX(-50px) translateY(-50px);
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

         {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </section>
  );
};

export default CTA;
